var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6099_90952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0923 5.22005C23.2888 5.57609 22.4257 5.81666 21.5183 5.92539C22.4546 5.36516 23.155 4.48341 23.489 3.44468C22.6093 3.96718 21.6466 4.33496 20.6426 4.53204C19.9675 3.81117 19.0732 3.33337 18.0987 3.17281C17.1242 3.01226 16.1239 3.17793 15.2532 3.64411C14.3825 4.11029 13.69 4.85089 13.2834 5.75094C12.8767 6.65099 12.7785 7.66012 13.0042 8.62166C11.2217 8.53216 9.47807 8.06889 7.88629 7.26189C6.29451 6.45489 4.8902 5.32221 3.7645 3.93736C3.3796 4.60132 3.15828 5.37113 3.15828 6.19098C3.15785 6.92903 3.3396 7.65578 3.68741 8.30674C4.03521 8.9577 4.53832 9.51275 5.15209 9.92264C4.44028 9.89999 3.74417 9.70765 3.12171 9.36164V9.41938C3.12164 10.4545 3.4797 11.4578 4.13515 12.259C4.7906 13.0602 5.70305 13.61 6.71769 13.815C6.05737 13.9937 5.36507 14.02 4.69309 13.892C4.97936 14.7827 5.53699 15.5615 6.28791 16.1196C7.03884 16.6776 7.94546 16.9868 8.88086 17.0039C7.29297 18.2505 5.33192 18.9266 3.3132 18.9237C2.95561 18.9238 2.59831 18.9029 2.24316 18.8611C4.29228 20.1786 6.6776 20.8778 9.11373 20.8751C17.3603 20.8751 21.8685 14.045 21.8685 8.12128C21.8685 7.92883 21.8637 7.73445 21.8551 7.542C22.732 6.90784 23.4889 6.12256 24.0904 5.22294L24.0923 5.22005V5.22005Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6099_90952"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.0943,
    height: 23.0943,
    fill: "white",
    transform: "translate(0.960205 0.547119)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.02c443db71249cf389f7be5ee07d5f5c.svg";
export { ForwardRef as ReactComponent };